import React from "react"
import { Link } from "gatsby"
import habitatHillsLogo from "../../images/habitat-hills-logo.png"

export default class Navigation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isNavbarOpen: false,
      theStyleClassForNavbarMenus:
        "collapse navbar-collapse justify-content-end",
    }
  }

  handleToggler = () => {
    if (this.state.isNavbarOpen) {
      this.setState({
        isNavbarOpen: false,
        theStyleClassForNavbarMenus:
          "collapse navbar-collapse justify-content-end",
      })
    } else {
      this.setState({
        isNavbarOpen: true,
        theStyleClassForNavbarMenus:
          "collapse navbar-collapse show justify-content-end",
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-md bg-light navbar-light fixed-top align-items-center shadow">
          <div className="container">
            <Link to="/" className="d-flex navbar-brand">
              <img
                style={{ height: "3rem" }}
                src={habitatHillsLogo}
                alt="Habitat Hills logo"
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => this.handleToggler()}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className={this.state.theStyleClassForNavbarMenus}>
              <div className="d-flex justify-content-end text-right">
                <ul className="navbar-nav">
                  {this.props.links.map(link => {
                    return (
                      <li key={link.id} className="nav-item">
                        <Link className="nav-link" to={link.link}>
                          {link.name}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </React.Fragment>
    )
  }
}
